import mainOverrides from '^/utils/mainOverrides'
import MobileHomePageCategories from 'vue-src/top-level/mobile-home-page-categories'
function revolutionSliderTest(){
  return mainOverrides.revolutionSliderTest()
}

function extraComponents({Vue, store, inits}, position){
  if(position===0 &&
      document.querySelectorAll('#mobile-gunold-simple-home').length === 1){
    inits.push('gunold-mobile-home-page');
    new Vue({
      el:"#mobile-gunold-simple-home",
      store,
      render(e){
        return e(MobileHomePageCategories);
      },
    })
  }
}

export default {
  ...mainOverrides,
  revolutionSliderTest,
  extraComponents
}



// WEBPACK FOOTER //
// ./ixcms/themes/gunoldusa/src/vue-src/utils/mainOverrides.js